import type { AdjustmentType } from '../enums/AdjustmentType'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { AdjustmentReasonMiniEntity } from '@/features/adjustmentReason/domain/entities/AdjustmentReasonMiniEntity'

export class CreateUpdateAdjustmentEntity {
  driver?: DriverEntity
  amount?: number
  type?: AdjustmentType
  adjustmentReason?: AdjustmentReasonMiniEntity
  note?: string
  effectiveDate?: string
}
